import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {discountsEdit_template} from "../components/templates/discountsEdit_template";
import {imagePickerHelper} from '../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;

export class discount_edit extends vnModule_knockoutJS {

    protected discountsEditTemplate: discountsEdit_template;
    protected categoriesData: any[] = [];
    protected branchesData: any[] = [];
    public imagePickerHelper: imagePickerHelper;

    protected getModuleName(): string {
        return "discount_edit";
    }

    public getIdBrand() {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    buildContent(): Element[] {
        this.discountsEditTemplate = new discountsEdit_template("discountsEditTemplate", this.viewModel, this);

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Discount Form");

        return [this.discountsEditTemplate.build()];
    }

    fillPage(): void {
        this.getReferences();
    }

    protected getReferences(): void {
        if (this.XHRHdls['getReferences']) {
            this.XHRHdls['getReferences'].cancelAndReset();
        }
        this.loadingIn(this.discountsEditTemplate.builtTemplate);

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/references/';
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);

        this.XHRHdls['getReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getReferences'].onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdls['getReferences'].execute();
    }

    protected onGetReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);

                if (response.categories) {
                    obj.categoriesData = response.categories;
                    const flatCategories = obj.flattenCategories(response.categories);
                    obj.discountsEditTemplate.setCategoryOptions(flatCategories);
                }

                if (response.branches) {
                    obj.branchesData = response.branches;
                    obj.discountsEditTemplate.setBranchOptions(response.branches);
                }

                obj.getFormData();
            });
        };
    }

    protected flattenCategories(categories: any[], parentName: string = ''): any[] {
        let flat: any[] = [];
        for (const cat of categories) {
            const displayName = parentName ? `${parentName} > ${cat.name}` : cat.name;
            flat.push({ id: cat.id, name: displayName });
            if (cat.children && cat.children.length > 0) {
                flat = flat.concat(this.flattenCategories(cat.children, displayName));
            }
        }
        return flat;
    }

    protected getFormData(): void {
        const discountId = this.getVnAppZone().app.params.discountId;

        if (this.XHRHdls['getFormData']) {
            this.XHRHdls['getFormData'].cancelAndReset();
        }
        
        if (discountId && !isNaN(discountId)) {
            this.viewModel["discountsEditTemplate"].id(discountId);

            const idBrand = this.getVnAppZone().app.params.idBrand;
            const usrReq_url: string = '/api/discounts/get/' + discountId + '/';
            const usrReq_params: string[][] = [];
            usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);

            this.XHRHdls['getFormData'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdls['getFormData'].onReadyStateFunction = this.onGetFormDataReturn;
            this.XHRHdls['getFormData'].execute();
        } else {
            this.loadingOut(this.discountsEditTemplate.builtTemplate);
        }
    }

    protected onGetFormDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);

                if (response.discount != null) {
                    obj.discountsEditTemplate.setDiscountData(response.discount);
                }

                obj.loadingOut(obj.discountsEditTemplate.builtTemplate);
            });
        };
    }

    protected save(): void {
        if (this.XHRHdls['save']) {
            this.XHRHdls['save'].cancelAndReset();
        }

        this.loadingIn(this.discountsEditTemplate.builtTemplate);
        this.discountsEditTemplate.clearMessages();

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const discountId = this.getVnAppZone().app.params.discountId;
        let formReq_url: string;
        if (discountId && !isNaN(discountId)) {
            formReq_url = '/api/discounts/save/' + discountId + '/';
        } else {
            formReq_url = '/api/discounts/save/';
        }
        const formReq_params: string[][] = [];

        const viewModelData = this.discountsEditTemplate.getViewModelForRequest();
        viewModelData.brandId = idBrand;

        const validationMessages = [];
        if (!viewModelData.name || !viewModelData.name.trim()) {
            validationMessages.push({
                field: 'name',
                label: 'Discount Headline / Name',
                messages: ['Discount name is required.']
            });
        }
        if (!viewModelData.idMerchant) {
            validationMessages.push({
                field: 'idMerchant',
                label: 'Merchant / Company',
                messages: ['Merchant is required.']
            });
        }
        if (validationMessages.length > 0) {
            this.discountsEditTemplate.setValidationMessages(validationMessages);
            window.scrollTo(0, 0);
            this.loadingOut(this.discountsEditTemplate.builtTemplate);
            return;
        }

        if (typeof viewModelData.slug === 'string' && viewModelData.slug.trim() === '') {
            delete viewModelData.slug;
        }

        formReq_params.push(["data", ko.toJSON(viewModelData)]);

        this.XHRHdls['save'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls['save'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['save'].onReadyStateFunction = this.onPostDiscountReturn;
        this.XHRHdls['save'].execute();
    }

    protected onPostDiscountReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }

            let responseParsed: any = {};
            try {
                responseParsed = JSON.parse(req.request.response || '{}');
            } catch (_e) {
                responseParsed = {};
            }

            const status = Number(req.request.status);
            const url: string = '/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/discounts/';
            const discountIdParam = obj.getVnAppZone().app.params.discountId;
            const isEdit = !!(discountIdParam && !isNaN(Number(discountIdParam)));

            if (status === 200 || status === 201) {
                const successMessage = isEdit
                    ? 'Discount updated successfully.'
                    : 'Discount created successfully.';
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    successMessage
                );
                obj.getVnAppZone().showNotificationToModule();
                obj.discountsEditTemplate.clearMessages();
                page.redirect(url);
                obj.loadingOut(obj.discountsEditTemplate.builtTemplate);
                return;
            }

            if (status === 400) {
                if (responseParsed.validations && responseParsed.validations.length > 0) {
                    obj.discountsEditTemplate.setValidationMessages(responseParsed.validations);
                } else {
                    const errorMessage = responseParsed.error || responseParsed.message || 'Unable to save discount.';
                    obj.discountsEditTemplate.setSingleValidationMessage({
                        field: 'error',
                        label: 'Discount',
                        message: errorMessage
                    });
                }
                window.scrollTo(0, 0);
                obj.loadingOut(obj.discountsEditTemplate.builtTemplate);
                return;
            }

            obj.discountsEditTemplate.setSingleValidationMessage({
                field: 'error',
                label: String(status || 'Error'),
                message: responseParsed.message || 'Could not save discount. Please review the highlighted issues.'
            });
            window.scrollTo(0, 0);
            obj.loadingOut(obj.discountsEditTemplate.builtTemplate);
        };
    }

    public cancelForm() {
        this.cancel();
    }

    public cancel(): void {
        const url: string = '/brand/' + this.getVnAppZone().app.params.idBrand + '/config/discounts/';

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Discount Action Canceled!");
        this.discountsEditTemplate.clearMessages();

        page.redirect(url);
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    // =========================================
    // MERCHANT AUTOCOMPLETE
    // =========================================

    protected getSuggestions(keyword: string, idSourceElement: string): void {
        if (idSourceElement === 'merchantSelector') {
            this.searchMerchants(keyword);
        }
    }

    protected searchMerchants(keyword: string): void {
        if (this.XHRHdls['merchantSearch']) {
            this.XHRHdls['merchantSearch'].cancelAndReset();
        }

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/merchants/get/';
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON({
            brandId: idBrand,
            filters: { keyword: keyword },
            pagination: { pageNumber: 1, itemPerPage: 20 },
            orderBy: 'name',
            orderByDirection: 'ASC'
        })]);

        this.XHRHdls['merchantSearch'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['merchantSearch'].onReadyStateFunction = this.onSearchMerchantsReturn;
        this.XHRHdls['merchantSearch'].execute();
    }

    protected onSearchMerchantsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                const merchants = response.merchants || [];
                const options = merchants.map(m => ({
                    id:    m.id,
                    name:  m.name,
                    image: m.image || null,
                    isSelectable: 1
                }));
                obj.discountsEditTemplate.setMerchantSuggestions(options);
            });
        };
    }

    protected onAutocompleteOptionChange(idElement: string): void {
        if (idElement === 'merchantSelector') {
            const merchant = this.discountsEditTemplate.merchantSelector.getOptionObj();
            if (merchant && merchant.image) {
                this.discountsEditTemplate.setLogoImage(merchant.image);
            } else {
                this.discountsEditTemplate.removeImage('discount_logo');
            }
        }
    }

    protected onAutocompleteInputClear(idElement: string): void {}
    protected onAutocompleteInputClick(idElement: string): void {}
    protected onAutocompleteAddNewSelected(idElement: string): void {}
    protected onAutocompleteAddNewInputChange(idElement?: string): void {}
    protected onAutocompleteAddNewInputClick(idElement: string): void {}
    protected onAutocompleteAcceptSuggestion(idElement: string): void {}
    protected onPromptInputChangeClear(idElement: string): void {}

    protected filterDropdownOnChange(idElement) {
        // Handle dropdown changes if needed
    }

    protected filterSimpleOnChange(idElement) {
        // Handle filter changes if needed
    }

    protected filterSimpleCancel() {
        // Handle filter cancellation
    }

    protected filterMultipleSelectorOnChange(idElement = null) {
        this.discountsEditTemplate.updateSelectedCategories();
        this.discountsEditTemplate.updateSelectedBranches();
    }

    protected insertImage(image, target, extra_option) {
        if (target === "discount_image") {
            this.discountsEditTemplate.setDiscountImage(image);
        } else if (target === "discount_logo") {
            this.discountsEditTemplate.setLogoImage(image);
        }
    }

    public removeImage(target) {
        this.discountsEditTemplate.removeImage(target);
    }

    public setIsImageOptimized(val) {
        // Implement if needed
    }
}



// WEBPACK FOOTER //
// ./js/modules/discount_edit.ts